/** Optional processing requires an explicit category grant in every build.
 * The legacy flag argument remains only for compatibility with existing callers.
 * No environment setting can turn a refusal into permission.
 */
import type { OptionalCategory } from "./categories";
import { getConsentState, isAllowed, type PrivacyConsentState } from "./store";

export function isEnforcementEnabled(): boolean { return import.meta.env.VITE_CONSENT_ENFORCEMENT === "true"; }
export function decideAllowed(category: OptionalCategory, state: PrivacyConsentState, _legacyEnforcing?: boolean): boolean {
  return isAllowed(category, state);
}
export function allowCategory(category: OptionalCategory): boolean {
  return typeof window !== "undefined" && decideAllowed(category, getConsentState());
}
export const allowAnalytics = () => allowCategory("analytics");
export const allowAdvertising = () => allowCategory("advertising");
